// ---------------------------------------------------------
// Datei: hubspotDocuments.ts
// Zweck: Metadaten für HubSpot Dokument-Properties
// Besonderheiten:
// - Mapping von technischen Property-Namen zu deutschen Labels
// - Pflicht-Status und Phasen-Zuordnung
// - Single Source of Truth für Dokument-Konfiguration
// ---------------------------------------------------------

// === Dokument-Metadaten-Typ ===
export interface DocumentMetadata {
  label: string;      // Deutscher Anzeigename
  required: boolean;  // Ist das Dokument ein Pflichtdokument?
  phase: string;      // In welcher Phase wird es benötigt?
}

// === Mapping: Property-Name → Metadaten ===
// Diese Konstante definiert alle verfügbaren HubSpot-Dokument-Properties
// und ihre Metadaten. Sie dient als Single Source of Truth für die UI.
//
// Warum diese Struktur?
// - Zentrale Konfiguration (statt verteilte Logik)
// - Type-Safe durch TypeScript Record
// - Einfach erweiterbar für neue Properties
export const HUBSPOT_DOCUMENT_PROPERTIES: Record<string, DocumentMetadata> = {
  // === Phase: Projekt angenommen ===
  heizlastberechnung: {
    label: 'Heizlastberechnung',
    required: true,
    phase: 'Projekt angenommen'
  },

  // === Phase: In Durchführung ===
  anmeldung_beim_energieversorger: {
    label: 'Anmeldung beim Energieversorger',
    required: true,
    phase: 'In Durchführung'
  },
  vollmacht_vom_kunden__energieversorger: {
    label: 'Vollmacht Energieversorger',
    required: true,
    phase: 'In Durchführung'
  },
  vollmacht_vom_kunden__gas: {
    label: 'Vollmacht Gas',
    required: false,
    phase: 'In Durchführung'
  },
  zusageschreiben_forderung: {
    label: 'Zusageschreiben Förderung',
    required: false,
    phase: 'In Durchführung'
  },

  // === Phase: Projekt abgeschlossen ===
  abmeldung_beim_bisherigen_versorgungunternehmen: {
    label: 'Abmeldung Versorger',
    required: false,
    phase: 'Projekt abgeschlossen'
  },
  abmeldung_der_feuerstatte: {
    label: 'Abmeldung Feuerstätte',
    required: false,
    phase: 'Projekt abgeschlossen'
  },

  // === Phase: Inbetriebnahme ===
  garantie5jahre: {
    label: '5-Jahres-Garantie',
    required: false,
    phase: 'Inbetriebnahme'
  },
  inbetriebnahmeprotokoll: {
    label: 'Inbetriebnahmeprotokoll',
    required: true,
    phase: 'Inbetriebnahme'
  },
  vdz_formular: {
    label: 'VDZ Formular',
    required: true,
    phase: 'Inbetriebnahme'
  },

  // === Phase: Vorab ===
  typenschild_altanlage: {
    label: 'Typenschild Altanlage',
    required: true,
    phase: 'Vorab'
  }
};

// === Hilfsfunktion: Liste aller Property-Namen ===
// Nützlich für Iterationen und Validierungen
export const DOCUMENT_PROPERTY_NAMES = Object.keys(HUBSPOT_DOCUMENT_PROPERTIES);

// === Hilfsfunktion: Anzahl Pflichtdokumente ===
// Berechnet, wie viele Pflichtdokumente es gibt
export const REQUIRED_DOCUMENTS_COUNT = Object.values(HUBSPOT_DOCUMENT_PROPERTIES)
  .filter(meta => meta.required)
  .length;
